export const personalLoans = {
    layout: {
        listTitle: 'Quem me deve',
        formTitle: 'Novo valor a receber',
    },
    list: {
        status: {
            settled: 'Quitado',
            writtenOff: 'Baixado',
        },
        defaultPersonName: 'Pessoa',
        loanOfDate: 'Registrado em {{date}}',
        // Curto porque vive na sub-linha recuada, que disputa espaço com o valor —
        // "Atrasado — combinado p/ 27 jul" era cortado no meio da data.
        overdueOn: 'Atrasado · {{date}}',
        agreedFor: 'Combinado p/ {{date}}',
        whenPossible: 'Quando der',
        ofAmount: 'de {{amount}}',
        open: 'em aberto',
        lent: 'no total',
        emptyTitle: 'Ninguém te deve por aqui',
        emptySubtitle: 'Registre o que alguém te deve — empréstimo, venda, racha de conta — pra acompanhar o saldo por pessoa, sem inflar seus relatórios de gastos.',
        emptyAction: 'Novo valor a receber',
        hero: {
            toReceiveFrom_one: 'A receber de {{count}} pessoa',
            toReceiveFrom_other: 'A receber de {{count}} pessoas',
            overdueAmount: '{{amount}} atrasado',
        },
        filters: {
            all: 'Todos',
            overdue: 'Atrasados',
            scheduled: 'Combinados',
            whenPossible: 'Quando der',
            empty: 'Ninguém neste filtro.',
        },
        person: {
            overdueDays_one: 'Atrasado há {{count}} dia',
            overdueDays_other: 'Atrasado há {{count}} dias',
            whenPossibleSince: 'Quando der · desde {{date}}',
            loanCount_one: '{{count}} valor a receber',
            loanCount_other: '{{count}} valores a receber',
        },
        endedSection: 'Encerrados',
        ended: {
            summary_one: '{{count}} valor a receber · {{amount}} no total',
            summary_other: '{{count}} valores a receber · {{amount}} no total',
        },
    },
    detail: {
        eventType: {
            receipt: 'Recebimento',
            writeOff: 'Baixa',
            reschedule: 'Data combinada',
        },
        eventRow: '{{type}} · {{date}}',
        eventAgreedFor: 'Combinado p/ {{date}}',
        agreedDateRemoved: 'Data combinada removida',
        balanceAfter: 'Saldo após: {{balance}}',
        excessBooked: 'Excedente de {{amount}} lançado como receita',
        defaultPersonName: 'Pessoa',
        lentOn: 'Registrado em {{date}}',
        registeredWithoutOutflow: 'sem saída de conta',
        openBalanceLabel: 'Em aberto',
        settledLabel: 'Quitado',
        writtenOffLabel: 'Baixado',
        agreedFor: 'Combinado p/ {{date}}',
        hero: {
            overdueDays_one: 'Atrasado há {{count}} dia',
            overdueDays_other: 'Atrasado há {{count}} dias',
            whenPossible: 'Quando der',
            // "resolvidos" e não "recebidos": o valor abatido inclui baixa parcial,
            // que não é dinheiro que voltou.
            received: '{{amount}} resolvidos',
            ofLent: 'de {{amount}} no total',
        },
        actions: {
            receipt: 'Recebi',
            reschedule: 'Remarcar',
        },
        scheduleTitle: 'Cronograma de recebimento',
        scheduleEdit: 'Editar',
        scheduleHint: 'Cada recebimento entra no fluxo de caixa como entrada esperada. O que cair abate sempre o mais antigo.',
        transactionsTitle: 'Lançamentos',
        transactionsHint: 'A saída e os recebimentos movem o caixa, mas só excedente e baixa entram nos relatórios.',
        historyTitle: 'Histórico',
        existingReceiptBadge: 'antes do app',
        emptyTitle: 'Nenhum lançamento deste valor',
    },
    receipt: {
        confirmButton: 'Confirmar recebimento',
        amountLabel: 'Valor recebido',
        excessHint: 'Abate {{principal}} do saldo; {{excess}} excedem e viram receita.',
        balanceHint: 'Saldo em aberto: {{balance}} — pode ser parcial.',
        datePlaceholder: 'Data',
        dateHelper: 'Data do recebimento',
        accountLabel: 'Conta que recebeu',
        accountPlaceholder: 'Selecionar conta...',
        excessCategoryLabel: 'Categoria do excedente',
        excessCategoryPlaceholder: 'Selecionar categoria de receita...',
        notesPlaceholder: 'Observação (opcional)',
        existingToggleLabel: 'Recebi antes de usar o Kontto',
        existingToggleHint: 'Abate o saldo sem movimentar conta — o dinheiro já está no saldo inicial.',
        existingOverBalanceHint: 'Não pode passar do saldo em aberto ({{balance}}).',
    },
    writeOff: {
        confirmButton: 'Dar baixa',
        amountLabel: 'Valor da baixa',
        overBalanceHint: 'Maior que o saldo em aberto ({{balance}}).',
        hint: 'Vira despesa na data da baixa, na categoria escolhida. Não mexe em conta — o dinheiro já saiu quando o valor foi registrado.',
        datePlaceholder: 'Data',
        dateHelper: 'Data da baixa',
        categoryLabel: 'Categoria da baixa',
        categoryPlaceholder: 'Selecionar categoria de despesa...',
        notesPlaceholder: 'Observação (opcional)',
    },
    schedule: {
        saveButton: 'Salvar cronograma',
        title: 'Cronograma de recebimento',
        hint: 'Cada recebimento esperado entra no fluxo de caixa projetado. É lembrete, não carnê — dá pra renegociar a cauda em aberto ou voltar pro "quando der". A soma tem que bater com o saldo em aberto.',
    },
    edit: {
        saveButton: 'Salvar alterações',
        amountLabel: 'Valor a receber',
        hintUntouched: 'Valor, data e conta ainda podem mudar — nada foi recebido nem baixado.',
        hintLocked: 'Valor, data e conta travam após o primeiro recebimento ou baixa; só as notas seguem editáveis.',
        datePlaceholder: 'Data',
        dateHelper: 'Data do registro',
        accountLabelExisting: 'Conta padrão de recebimento',
        accountLabelOutflow: 'Conta da saída',
        accountPlaceholder: 'Selecionar conta...',
        notesPlaceholder: 'Notas (opcional)',
    },
    rename: {
        confirmButton: 'Renomear',
        label: 'Nome da pessoa',
        placeholder: 'Ex.: Carlos',
        hint: 'Vale para todos os valores e lançamentos dessa pessoa.',
    },
    menu: {
        title: 'Valor a receber',
        editSchedule: 'Editar cronograma de recebimento',
        defineSchedule: 'Definir cronograma de recebimento',
        editLoan: 'Editar valor a receber',
        renamePerson: 'Renomear pessoa',
        writeOff: 'Dar baixa (não vou receber)',
        delete: 'Excluir valor a receber',
    },
    undoDialog: {
        writeOffTitle: 'Desfazer baixa',
        receiptTitle: 'Desfazer recebimento',
        writeOffMessage: 'Remove a despesa de {{amount}} e devolve o valor ao saldo em aberto.',
        receiptMessage: 'Remove o recebimento de {{amount}} e devolve o valor ao saldo em aberto. O saldo da conta é recalculado.',
        receiptMessageWithExcess: 'Remove o recebimento de {{amount}} (incluindo o excedente) e devolve o valor ao saldo em aberto. O saldo da conta é recalculado.',
        receiptMessageExisting: 'Remove o recebimento de {{amount}} e devolve o valor ao saldo em aberto. Nenhuma conta é afetada.',
        confirm: 'Desfazer',
    },
    deleteDialog: {
        title: 'Excluir valor a receber',
        message: 'Apaga o valor a receber e TODOS os lançamentos vinculados (saída, recebimentos, excedente e baixa). Os saldos das contas são recalculados. Essa ação não pode ser desfeita.',
        confirm: 'Excluir tudo',
    },
    scheduleEditor: {
        modeNone: 'Quando der',
        modeSingle: 'Data única',
        modeSchedule: 'Parcelar',
        noneHint: 'Sem data combinada. O valor vive só no "Quem me deve", fora do fluxo de caixa projetado.',
        pickDate: 'Escolher data',
        singleHint: 'O saldo inteiro ({{amount}}) é esperado nessa data.',
        timesLabel: '{{n}}×',
        startingFrom: 'a partir de',
        split: 'Dividir',
        addReceipt: 'Adicionar recebimento',
        sumOf: 'Soma {{sum}} de {{target}}',
        matches: 'Bate com o saldo',
        missing: 'Faltam {{amount}}',
        excess: 'Sobram {{amount}}',
    },
    pdf: {
        title: 'A receber — {{name}}',
        lentAmountLabel: 'Valor original',
        lentOnLabel: 'Registrado em',
        resolvedAmountLabel: 'Resolvido (recebido/baixado)',
        outstandingBalanceLabel: 'Saldo em aberto',
        statusLabel: 'Situação',
        statusOpen: 'Em aberto',
        scheduleSection: 'Cronograma de recebimento',
        historySection: 'Histórico',
        colDate: 'Data',
        colAmount: 'Valor',
        colType: 'Tipo',
        colBalanceAfter: 'Saldo após',
        noSchedule: 'Sem recebimentos pendentes.',
        noHistory: 'Nenhum recebimento ou baixa registrado.',
        exportError: 'Não foi possível gerar o PDF.',
    },
    // Descrições GERADAS pelo personalLoanRepository (dados criados/regravados no rename).
    // Match de sistema é por personalLoanEntryType, nunca por estas strings.
    generated: {
        loanTo: 'A receber de {{name}}',
        scheduledReceipt: 'Recebimento de {{name}}',
        receiptFrom: 'Recebimento de {{name}}',
        excessFrom: 'Excedente de {{name}}',
        writeOff: 'Baixa de valor a receber - {{name}}',
        personFallback: 'Pessoa',
    },
};
